import React from 'react'
import '../popup.common.css'
import styles from './Style.module.css'
import CustomModal from '../../Modal/CustomModal'
import PrimaryButton from '../../Buttons/PrimaryButton'
import SecondaryButton from '../../Buttons/SecondaryButton'

const NotWorkingWarningPopup = ({ onClose, onContinue }) => {
  return (
    <CustomModal
      show={true}
      onHide={onClose}
      hideCloseButton={true}
    >
      <div className={`popup ${styles.warningPopup}`}>
        <div className="header">
          <h2>Cannot Set Schedule to OFF</h2>
        </div>

        <div className="body">
          <p className={styles.warningMessage}>
            This therapist still has <strong>upcoming booking(s)</strong>.
          </p>
          <p className={styles.warningExplanation}>
            To protect clients and avoid last-minute disruptions, you must first:
          </p>
          <ul className={styles.actionList}>
            <li>Reassign the booking(s) to another therapist, or</li>
            <li>Cancel the booking(s) (with proper notification/refund if applicable)</li>
          </ul>
          <p className={styles.warningFooter}>
            Until all existing bookings are cleared or reassigned, this therapist <strong>cannot</strong> be set to OFF.
          </p>
        </div>

        <div className="footer">
          <SecondaryButton
             text="OFF anyway"
             onClick={onContinue}
          />
          <PrimaryButton
            text="Close"
            onClick={onClose}
            className={styles.closeButton}
          />
        </div>
      </div>
    </CustomModal>
  )
}

export default NotWorkingWarningPopup

